export const FolderIcon = ({ className = "" }) => (
  <svg viewBox="0 0 96 76" className={className} aria-hidden>
    <path d="M6 10a6 6 0 0 1 6-6h22l8 9h42a6 6 0 0 1 6 6v6H6z" fill="#E0A82E" />
    <rect x="6" y="18" width="84" height="54" rx="6" fill="#F5C04A" />
    <rect x="6" y="18" width="84" height="8" fill="#FFD66E" opacity="0.7" />
  </svg>
);
